import { render, staticRenderFns } from "./bulidaccess.vue?vue&type=template&id=25917e17&"
import script from "./bulidaccess.vue?vue&type=script&lang=js&"
export * from "./bulidaccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports